import { isNullOrUndefOrEmpty, jsonToUri, noOp } from "@civicscience/chops";

/**
 *
 * NOTE: onSearchPaging() wraps common event handling for CSPagination().onPage and
 * search related pagination.
 *
 * @param pagingData {{to: number, from: number, size: number, pageTotal: number, rules: Object}}
 * @param searchTerm {string|null}
 * @param isSearch {boolean}
 * @param defaultSize {number|null}
 * @param routePath {string}
 * @param history {object} history must contain push() method
 * @param overrides {object} url params object to be added with base search params.
 * @returns {boolean}
 */
const onSearchPaging = ({
  pagingData = {
    to: 0,
    from: 0,
    size: 0,
    pageTotal: 0,
    rules: {},
  },
  searchTerm = "",
  isSearch = false,
  defaultSize = 0,
  routePath = "",
  history = { push: noOp() },
  overrides = {},
}) => {
  if (isNullOrUndefOrEmpty(pagingData) || isNullOrUndefOrEmpty(routePath)) {
    return false;
  }

  const { to, size } = pagingData;

  const toUri = { page: to, ...overrides };
  if (isSearch) {
    toUri.search = `${searchTerm}`;
  }
  if (defaultSize !== size && !isNullOrUndefOrEmpty(size)) {
    toUri.size = size;
  }

  const searchParamStr = jsonToUri(toUri);

  history.push(`${routePath}?${searchParamStr}`);
  return true;
};

export default onSearchPaging;
